import { useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

import BusinessMobileMenu from "./BussinesMobileMenu";

import { handleLogout } from "../../utils/Logout";

import CloseIcon from "../../assets/icons/CloseModal.svg";
import UploadIcon from "../../assets/icons/Upload2.svg";
import HomeIcon from "../../assets/icons/Home.svg";
import MessageIcon from "../../assets/icons/Message.svg";
import BotIcon from "../../assets/icons/Bot.svg";
import HandSelectLeftImage from "../../assets/icons/HandSelectLeft.svg";
import DashboardIcon from "../../assets/icons/DashboardGauge.svg";
import ChannelsIcon from "../../assets/icons/Channels.svg";
import UsersIcon from "../../assets/icons/Users.svg";
import CatalogIcon from "../../assets/icons/Book.svg";
import SettingsIcon from "../../assets/icons/Settings.svg";
import LogoutIcon from "../../assets/icons/LogOut.svg";
import CalendarIcon from "../../assets/icons/Calendar.svg";
import ReportsIcon from "../../assets/icons/Report.svg";
import LucciIcon from "../../assets/Logo.svg";

import useBusinessStore from "../../state/businessStore";

import "./MobileMenu.scss";

const MobileMenu = ({ setIsMenuOpen }) => {
  const { t } = useTranslation("sidebar");

  const navigate = useNavigate();

  // :: State management with Zustand
  const { getSelectedBusinessDetails, getUserRole, activeModules } = useBusinessStore();
  const { selectedBusinessName, selectedBusinessLogo } =
    getSelectedBusinessDetails();
  const isCollaborator = getUserRole() === 'Collaborator';

  const isModuleActive = (key) =>
    Array.isArray(activeModules) && activeModules.includes(key);

  const handleToggle = () => {
    setIsMenuOpen(false);
  };

  const handleSignOut = () => {
    handleLogout(navigate);
  };

  function acortarTexto(texto, limite = 15) {
    return texto.length > limite ? texto.slice(0, limite) + "..." : texto;
  }

  return (
    <div className="wrapper">
      <BusinessMobileMenu />

      <aside className="mobile-overlay">
        <header className="sidebar__header">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <img
              src={selectedBusinessLogo}
              alt=""
              style={{ height: "30px", borderRadius: "8px" }}
            />
            <h1 className="sidebar__header-business">
              {!selectedBusinessName
                ? "Menu"
                : acortarTexto(selectedBusinessName, 17)}
            </h1>
          </div>
          {/* Expand / collapse button */}
          <button className="sidebar__header-toggle" onClick={handleToggle}>
            <img
              src={CloseIcon}
              className="sidebar__header-icon"
              alt="Panel icon"
            />
          </button>
        </header>

        {selectedBusinessName ? (
          <nav className="sidebar__navigation">
            <ul className="sidebar__navigation-menu">
              {/* <NavLink
                to="/luccichat"
                className="sidebar__navigation-link"
                activeclassname="active"
              >
                <li className="sidebar__navigation-item  ia__chat">
                  <span className="sidebar__navigation-text">LucciChat</span>
                  <img
                    src={LucciIcon}
                    className="sidebar__navigation-icon"
                    alt="Chat icon"
                  />
                </li>
              </NavLink> */}
              <li className="sidebar__navigation-item">
                <NavLink
                  to="/"
                  onClick={handleToggle}
                  className="sidebar__navigation-link"
                  activeclassname="active"
                >
                  <img
                    src={HomeIcon}
                    className="sidebar__navigation-icon"
                    alt="Home icon"
                  />
                  <span className="sidebar__navigation-text">
                    {t("sidebar.home")}
                  </span>
                </NavLink>
              </li>
              {!isCollaborator && (
              <li className="sidebar__navigation-item">
                <NavLink
                  to="/inbox"
                  onClick={handleToggle}
                  className="sidebar__navigation-link"
                  activeclassname="active"
                >
                  <img
                    src={MessageIcon}
                    className="sidebar__navigation-icon"
                    alt="Message icon"
                  />
                  <span className="sidebar__navigation-text">
                    {t("sidebar.inbox")}
                  </span>
                </NavLink>
              </li>
              )}
              <li className="sidebar__navigation-item">
                <NavLink
                  to="/customers"
                  onClick={handleToggle}
                  className="sidebar__navigation-link"
                  activeclassname="active"
                >
                  <img
                    src={UsersIcon}
                    className="sidebar__navigation-icon"
                    alt="Customers icon"
                  />
                  <span className="sidebar__navigation-text">
                    {t("sidebar.customers")}
                  </span>
                </NavLink>
              </li>
              <li className="sidebar__navigation-item">
                <NavLink
                  to="/catalog"
                  onClick={handleToggle}
                  className="sidebar__navigation-link"
                  activeclassname="active"
                >
                  <img
                    src={CatalogIcon}
                    className="sidebar__navigation-icon"
                    alt="Catalog icon"
                  />
                  <span className="sidebar__navigation-text">
                    {t("sidebar.catalog")}
                  </span>
                </NavLink>
              </li>
              {!isCollaborator && (
              <li className="sidebar__navigation-item">
                <NavLink
                  to="/lucci"
                  onClick={handleToggle}
                  className="sidebar__navigation-link"
                  activeclassname="active"
                >
                  <img
                    src={BotIcon}
                    className="sidebar__navigation-icon"
                    alt="Bot icon"
                  />
                  <span className="sidebar__navigation-text">Lucci AI</span>
                </NavLink>
              </li>
              )}
              {!isCollaborator && (
              <li className="sidebar__navigation-item">
                <NavLink
                  to="/channel"
                  onClick={handleToggle}
                  className="sidebar__navigation-link"
                  activeclassname="active"
                >
                  <img
                    src={ChannelsIcon}
                    className="sidebar__navigation-icon"
                    alt="Channel admin icon"
                  />
                  <span className="sidebar__navigation-text">
                    {t("sidebar.channels")}
                  </span>
                </NavLink>
              </li>
              )}
              <li className="sidebar__navigation-item">
                <NavLink
                  to="/schedule"
                  className="sidebar__navigation-link"
                  activeclassname="active"
                >
                  <img
                    src={CalendarIcon}
                    className="sidebar__navigation-icon"
                    alt="Calendar icon"
                  />
                  <span className="sidebar__navigation-text">
                    {t("sidebar.schedule")}
                  </span>
                </NavLink>
              </li>
              {isModuleActive("reports") && !isCollaborator && (
              <li className="sidebar__navigation-item">
                <NavLink
                  to="/reports"
                  onClick={handleToggle}
                  className="sidebar__navigation-link"
                  activeclassname="active"
                >
                  <img
                    src={ReportsIcon}
                    className="sidebar__navigation-icon"
                    alt="Reports icon"
                  />
                  <span className="sidebar__navigation-text">
                    {t("sidebar.reports")}
                  </span>
                </NavLink>
              </li>
              )}
              {!isCollaborator && (
              <li className="sidebar__navigation-item">
                <NavLink
                  to="/user"
                  onClick={handleToggle}
                  className="sidebar__navigation-link"
                  activeclassname="active"
                >
                  <img
                    src={UsersIcon}
                    className="sidebar__navigation-icon"
                    alt="Integrations icon"
                  />
                  <span className="sidebar__navigation-text">
                    {t("sidebar.users")}
                  </span>
                </NavLink>
              </li>
              )}
              {/* <li className="sidebar__navigation-item">
                <NavLink
                  to="/upload"
                  className="sidebar__navigation-link"
                  activeclassname="active"
                >
                  <img
                    src={UploadIcon}
                    className="sidebar__navigation-icon"
                    style={{ width: "1.9rem" }}
                    alt="Bot icon"
                  />
                  <span className="sidebar__navigation-text">Upload file</span>
                </NavLink>
              </li> */}
            </ul>
          </nav>
        ) : (
          <div className="sidebar__navigation">
            <img src={HandSelectLeftImage} alt="" />
            <h2>Select a business</h2>
            <p>
              To enable all features, please choose the business you want to
              view.
            </p>
          </div>
        )}

        <section className="sidebar__misc">
          {!isCollaborator && (
          <nav className="misc__actions">
            <ul className="misc__actions-list">
              <li className="misc__actions-item">
                <NavLink
                  to="/settings"
                  className="misc__actions-link"
                  activeclassname="active"
                >
                  <img
                    src={SettingsIcon}
                    className="misc__actions-icon"
                    alt="Settings icon"
                  />
                  <span className="misc__actions-text">
                    {t("sidebar.settings")}
                  </span>
                </NavLink>
              </li>
            </ul>
          </nav>
          )}

          {/*         <div className="misc__theme">
          <div className="misc__theme-divider"></div>
          <div className='misc__theme-buttons'>
            <button className='misc__theme-btn misc__theme-btn--light'>
              <img src={LightIcon} className='misc__theme-icon' alt="Light Mode" />
            </button>
            <button className='misc__theme-btn misc__theme-btn--dark'>
              <img src={DarkIcon} className='misc__theme-icon' alt="Dark Mode" />
            </button>
          </div>
        </div> */}

          <nav className="misc__actions">
            <ul className="misc__actions-list">
              <li className="misc__actions-item">
                <button
                  onClick={handleSignOut}
                  className="misc__actions-link misc__actions-link--logout"
                >
                  <img
                    src={LogoutIcon}
                    className="misc__actions-icon"
                    alt="Logout icon"
                  />
                  <span className="misc__actions-text">
                    {t("sidebar.logout")}
                  </span>
                </button>
              </li>
            </ul>
          </nav>
        </section>
      </aside>
    </div>
  );
};

export default MobileMenu;
